import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _BREAKPOINT_COLS;
export var AMOUNT_OF_COLUMNS_DESKTOP = 3;
export var AMOUNT_OF_COLUMNS_TABLET = 2;
export var AMOUNT_OF_COLUMNS_MOBILE = 1;
export var TABLET_BREAKPOINT = 991;
export var MOBILE_BREAKPOINT = 767;
export var BREAKPOINT_COLS = (_BREAKPOINT_COLS = {
  "default": AMOUNT_OF_COLUMNS_DESKTOP
}, _defineProperty(_BREAKPOINT_COLS, TABLET_BREAKPOINT, AMOUNT_OF_COLUMNS_TABLET), _defineProperty(_BREAKPOINT_COLS, MOBILE_BREAKPOINT, AMOUNT_OF_COLUMNS_MOBILE), _BREAKPOINT_COLS);